import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, FormHelperText,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { MaterialMaster } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMatStkValue } from '../../Store/PHPSlice/MatInward';
import { fetchEmployeeData } from '../../Store/PHPSlice/Employee';
import { createMatOutwardEntry } from '../../Store/PHPSlice/MatOutward';
import { selectMaterials, selectEmployees, selectMatInwardData } from '../Selectors/Master/OutwardSelectors';
import { errorStyles } from '../../Utils/table';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import axios from 'axios';


const SOMaterialOut = ({ soId, itemId, qtyArr, onSave }) => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: '',
        outwardNo: '',
        empId: '',
        materialNm: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loading, setLoading] = useState(false);

    const [materialdata, setMaterialdata] = useState([]);
    const [matInfodata, setMatInfodata] = useState([]);
    const [materialSktlink, setMaterialStklink] = useState([]);
    const dispatch = useDispatch();

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const materials = useSelector(selectMaterials);
    const employees = useSelector(selectEmployees);
    const stk_value = useSelector(selectMatInwardData);

    useEffect(() => {
        dispatch(fetchMaterialData());
        dispatch(fetchEmployeeData());
    }, [dispatch]);

    useEffect(() => {
        fetchMaterialSOItemWiseList(soId, itemId)
    }, [soId, itemId]);
    // console.log(soId, itemId);

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        // if (dropdownType === 'materialNm') {
        //     fetchMaterialSOItemWiseList2(soId, itemId, value);
        // }
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const fetchMaterialStockBarcodeWise = async (id) => {
        try {
            const result = await axios.get(
                `${baseUrl}?apicall=getMaterialStockBarcodeWise&matId=${id}`
            );

            if (result?.data?.status === "failed") {
                alert(result.data.msg);
                setMaterialStklink(prev => {
                    const exists = prev.some(item => item.matId === id);
                    if (exists) {
                        return prev; // don't add duplicate
                    }
                    return [...prev, { matId: id }];
                });

                return;
            } else {
                setMaterialStklink(prev =>
                    prev.filter(item => item.matId !== id)
                );
            }

            const rows = result?.data?.data || [];

            setTableRows(prev => {
                // collect existing barcodes
                const existingBarcodes = new Set(prev.map(r => r.barcode));

                // filter only NEW barcodes
                const newRows = rows.filter(r => !existingBarcodes.has(r.barcode));

                // if all barcodes already exist
                if (newRows.length === 0) {
                    alert("This barcode already exists in the table");
                    return prev;
                }

                return [...prev, ...newRows];
            });

        } catch (error) {
            console.error('error', error);
        }
    };

    const fetchMaterialSOItemWiseList = async (soId, itemId) => {
        try {
            const result = await axios.get(
                `${baseUrl}?apicall=getMaterials_SOItemWise&soId=${soId}&itemId=${itemId}`
            );
            // console.log(result.data);
            setMaterialdata(result.data?.data);
        } catch (error) {
            console.error('error', error);
        }
    };

    const fetchMaterialSOItemWiseList2 = async (soId, itemId, matId) => {
        try {
            const result = await axios.get(
                `${baseUrl}?apicall=getMaterials_SOItemWise&soId=${soId}&itemId=${itemId}&matId=${matId}`
            );
            // console.log(result.data);
            // setMatInfodata(result.data.info);

            const hasDuplicate = matInfodata.some(
                existing => existing.matId === result.data.info.matId
            );
            if (hasDuplicate) {
                console.error("matId already exists");
                // show toast / alert here
            } else {
                setMatInfodata(prev => [...prev, result.data.info]);
            }
        } catch (error) {
            console.error('error', error);
        }
    };


    const handleAddMaterial = () => {
        const selectedMaterial = materials.data.find(item => item.ID === formData.materialNm);
        const mateId = selectedMaterial?.ID;

        if (!selectedMaterial) {
            alert("Please select a material first!");
            return;
        }

        // dispatch(fetchMatStkValue(mateId))
        //     .unwrap()
        //     .then((res) => {
        //         const inwardQty = res.data?.[0]?.inwardqty ?? 0;
        //         const packetQty = res.data?.[0]?.packetqty ?? 0;
        //         const totalQty = res.data?.[0]?.totqty ?? 0;
        //         setTableRows((prevRows) => [
        //             ...prevRows,
        //             {
        //                 id: prevRows.length + 1,
        //                 materialId: selectedMaterial.ID,
        //                 materialNm: selectedMaterial.materialNm,
        //                 description: selectedMaterial.description || '',
        //                 size: selectedMaterial.size || '',
        //                 packets: selectedMaterial.packets || '',
        //                 packetqty: packetQty,
        //                 inwardqty: inwardQty, // ✅ this will now show proper inward qty
        //                 totqty: totalQty,
        //                 qty: '' // outward qty left empty
        //             }
        //         ]);
        //     })
        //     .catch((err) => {
        //         console.error('Error fetching stock value:', err);
        //     });

        fetchMaterialStockBarcodeWise(mateId);
        fetchMaterialSOItemWiseList2(soId, itemId, mateId);
        setFormData({
            ...formData,
            materialNm: ''
        });
    };

    const handleInputChange = (index, field, value) => {
        setTableRows(prev => {
            const updatedRows = [...prev];

            const numericValue =
                value === '' || value === '.' ? 0 : parseFloat(value);

            const mtype = updatedRows[index].mtype;
            const perpacket = parseFloat(updatedRows[index].perpktqty) || 0;
            const pktqty = parseFloat(updatedRows[index].mqty) || 0;
            const singlemat = (perpacket * pktqty).toFixed(2);
            if (field === 'outqty') {
                const stkQty = parseFloat(updatedRows[index].balpqty) || 0;

                if (numericValue > stkQty) {
                    alert(`Packet Outward Qty cannot be greater than Stock Packet Qty (${stkQty})`);
                    return prev;
                }
                if (mtype === "Mtr") {
                    const totmtr = (singlemat * numericValue).toFixed(2);
                    updatedRows[index].outMtr = totmtr;
                    const oneinch = 39.3701;
                    updatedRows[index].outInch = (oneinch * totmtr).toFixed(2);
                    const totqty = (singlemat * numericValue).toFixed(2);
                    updatedRows[index].outBoxQty = totqty;
                }

                if (mtype === "Inch") {
                    const totinches = (singlemat * numericValue).toFixed(2);
                    const oneinch = 39.3701;
                    updatedRows[index].outInch = totinches;
                    const totmtr = (totinches / oneinch).toFixed(2);
                    updatedRows[index].outMtr = totmtr;
                    const outboxqty = (perpacket * numericValue).toFixed(2);
                    updatedRows[index].outBoxQty = outboxqty;
                }
                if (mtype === "Pcs") {
                    const totboxqty = (singlemat * numericValue).toFixed(2);
                    updatedRows[index].outBoxQty = totboxqty;
                    updatedRows[index].outInch = 0;
                    updatedRows[index].outMtr = 0;

                }

            }
            if (field === 'outBoxQty') {
                const stkboxqty = parseFloat(updatedRows[index].balTotqty) || 0;

                if (numericValue > stkboxqty) {
                    alert(`Total Outward Qty cannot be greater than Stock Total Qty (${stkboxqty})`);
                    return prev;
                }

                // if (mtype === "Mtr") {
                //     const totmtr = (numericValue * pktqty).toFixed(2);
                //     const totoutqty = (numericValue / perpacket).toFixed(2);
                //     updatedRows[index].outqty = totoutqty;
                //     updatedRows[index].outMtr = totmtr;
                //     const oneinch = 39.3701;
                //     updatedRows[index].outInch = (oneinch * totmtr).toFixed(2);
                // }

                // if (mtype === "Inch") {
                //     const totinches = (pktqty * numericValue).toFixed(2);
                //     const oneinch = 39.3701;
                //     updatedRows[index].outInch = totinches;
                //     const totmtr = (totinches / oneinch).toFixed(2);
                //     updatedRows[index].outMtr = totmtr;
                //     const totoutqty = (numericValue / perpacket).toFixed(2);
                //     updatedRows[index].outqty = totoutqty;
                // }
                if (mtype === "Pcs") {
                    const totoutqty = (numericValue / singlemat).toFixed(2);
                    updatedRows[index].outqty = totoutqty;
                    updatedRows[index].outInch = 0;
                    updatedRows[index].outMtr = 0;
                }
            }

            if (field === 'outMtr') {
                const stkMtr = parseFloat(updatedRows[index].balmtr) || 0;

                if (numericValue > stkMtr) {
                    alert(`Outward Mtr cannot be greater than Stock Mtr (${stkMtr})`);
                    return prev;
                }

                if (mtype === "Mtr") {
                    const outboxqty = (numericValue / pktqty).toFixed(2);
                    const totoutqty = (numericValue / singlemat).toFixed(2);
                    updatedRows[index].outBoxQty = 0;
                    updatedRows[index].outqty = totoutqty;
                    updatedRows[index].outMtr = numericValue;
                    const oneinch = 39.3701;
                    updatedRows[index].outInch = (oneinch * numericValue).toFixed(2);
                }

                if (mtype === "Inch") {
                    const oneinch = 39.3701;
                    const totinches = (oneinch * numericValue).toFixed(2);
                    updatedRows[index].outInch = totinches;
                    const totoutqty = (totinches / singlemat).toFixed(2);
                    updatedRows[index].outqty = totoutqty;
                    const outboxqty = (totinches / singlemat).toFixed(2);
                    updatedRows[index].outBoxQty = 0;
                }
                // if (mtype === "Pcs") {
                //     const totoutqty = (numericValue / singlemat).toFixed(2);
                //     updatedRows[index].outqty = totoutqty;
                //     updatedRows[index].outInch = 0;
                //     updatedRows[index].outMtr = 0;
                // }
            }

            if (field === 'outInch') {
                const stkInches = parseFloat(updatedRows[index].balInch) || 0;

                if (numericValue > stkInches) {
                    alert(`Outward Inches cannot be greater than Stock Inches (${stkInches})`);
                    return prev;
                }

                if (mtype === "Mtr") {
                    const oneinch = 39.3701;
                    const totmtr = (numericValue / oneinch).toFixed(2);
                    updatedRows[index].outMtr = totmtr;
                    const outboxqty = (totmtr / pktqty).toFixed(2);
                    const totoutqty = (outboxqty / perpacket).toFixed(2);
                    updatedRows[index].outqty = totoutqty;
                    updatedRows[index].outBoxQty = 0;
                }

                if (mtype === "Inch") {
                    const oneinch = 39.3701;
                    const totmtr = (numericValue / oneinch).toFixed(2);
                    updatedRows[index].outMtr = totmtr;
                    const outboxqty = (numericValue / pktqty).toFixed(2);
                    const totoutqty = (outboxqty / perpacket).toFixed(2);
                    updatedRows[index].outBoxQty = 0;
                    updatedRows[index].outqty = totoutqty;
                }
                // if (mtype === "Pcs") {
                //     const totoutqty = (numericValue / singlemat).toFixed(2);
                //     updatedRows[index].outqty = totoutqty;
                //     updatedRows[index].outInch = 0;
                //     updatedRows[index].outMtr = 0;
                // }
            }

            updatedRows[index] = {
                ...updatedRows[index],
                [field]: numericValue
            };

            return updatedRows;
        });
    };


    const handleCheckboxChange = (rowId) => {
        if (selectedRows.includes(rowId)) {
            setSelectedRows(selectedRows.filter(id => id !== rowId));
        } else {
            setSelectedRows([...selectedRows, rowId]);
        }
    };

    const handleDeleteMaterial = () => {
        setTableRows(tableRows.filter(row => !selectedRows.includes(row.id)));
        setSelectedRows([]);
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.empId) newErrors.empId = 'Employee Name is required';
        // if (!formData.materialNm) newErrors.materialNm = 'Material Name is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }


        if (tableRows.length > 0) {
            // var finalObject = {
            //     dt: formData.dt,
            //     outwardNo: formData.outwardNo,
            //     empId: formData.empId,
            //     matId: tableRows.map(row => row.materialId),
            //     pkt: tableRows.map(row => row.packets),
            //     packetqty: tableRows.map(row => row.packetqty),
            //     qty: tableRows.map(row => row.qty),
            //     userId: formData.userId
            // };

            var finalObject = {
                dt: formData.dt,
                outwardNo: formData.outwardNo,
                empId: formData.empId,
                tableRows: tableRows,
                userId: formData.userId
            };
            // console.log(finalObject);
            setLoading(false);
            try {
                const result = await dispatch(createMatOutwardEntry(finalObject)).unwrap();
                const data = result;
                console.log('POST request successful!', result);
                if (data.status === "success") {
                    alert(data.msg);
                    window.location.reload();
                } else {
                    const msg = Array.isArray(data.msg) ? data.msg.join("\n") : data.msg;
                    alert(msg);
                }
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }

        } else {
            alert("Select Employee & Material & Enter table details");
        }



    };

    const dropdownlist = [

        // {
        //     label: 'Employee',
        //     id: 'empId',
        //     options: employees?.data || [],
        //     value: formData.empId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'empId', value: newValue ? newValue.ID : '' } }, 'empId'),
        //     getOptionLabel: (option) => option.empNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     errors: errors.empId
        // },
        {
            label: 'Material',
            id: 'materialNm',
            // options: materials?.data || [],
            options: materialdata || [],
            value: formData.materialNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'materialNm', value: newValue ? newValue.ID : '' } }, 'materialNm'),
            getOptionLabel: (option) => `${option.materialNm}-${option.size}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            errors: errors.materialNm
        },
    ];

    // console.log(matInfodata)

    const handleStockAddClick = (id) => {
        window.open(`/new-material-inward-entry/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <div style={{ margin: '1% 0.5%' }}>

                {dropdownlist?.map((drop) => (
                    <DropdownWithBtn
                        key={drop.label}
                        label={drop.label}
                        id={drop.id}
                        options={drop.options}
                        value={drop.value}
                        onChange={drop.onChange}
                        isDesktop={isDesktop}
                        getOptionLabel={drop.getOptionLabel}
                        isOptionEqualToValue={drop.isOptionEqualToValue}
                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                        errors={drop.errors}
                    />
                ))}


                <Grid item xs={12} md={6}>
                    <Button variant="contained" color="primary" onClick={handleAddMaterial} sx={{ mr: 2 }} disabled={formData.materialNm === ""}>Add</Button>
                    {/* <Button variant="contained" color="primary" onClick={handleDeleteMaterial} disabled={selectedRows.length === 0}>Delete</Button> */}
                </Grid>

                <table>
                    <thead>
                        <tr>
                            <th>Material Name</th>
                            <th>Size</th>
                            {matInfodata?.[0]?.row.map(i => (
                                <th key={i.size}>{i.size}</th>
                            ))}
                            <th>Total</th>
                        </tr>
                    </thead>

                    <tbody>
                        {matInfodata?.map((mat, idx) => {
                            const rows = mat.row?.map((it, vidx) => {
                                const qty = parseFloat(qtyArr?.[vidx] ?? 0);
                                const matgqty = parseFloat(it.matgqty);
                                const matsize = parseFloat(it.matsize);

                                let issqty = 0;
                                let issmtr = 0;
                                let issInch = 0;
                                let issmqty = 0;

                                switch (mat.mtype) {
                                    case "Pcs":
                                        issqty = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                        issmqty = parseFloat(matgqty) * parseFloat(matsize) * qty;

                                        break;

                                        {/* case "Mtr":
                                        issmtr = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                        issInch = (issmtr * 39.3701).toFixed(2);
                                        issmqty = parseFloat(matgqty) * qty;

                                        break; */}
                                    case "Mtr":
                                    case "Inch":
                                        {/* issInch = matgqty * qty; */ }
                                        issInch = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                        issmtr = (issInch / 39.3701).toFixed(2);
                                        issmqty = parseFloat(matgqty) * qty;

                                        break;

                                    default:
                                        break;
                                }

                                return {
                                    ...it,
                                    issqty,
                                    issmtr,
                                    issInch,
                                    issmqty
                                };
                            });
                            const mtype = mat.mtype;

                            const totitemqty = qtyArr.reduce((acc, sum) => acc + parseFloat(sum || 0), 0);
                            const totissqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
                            const totissmtr = rows.reduce((acc, sum) => acc + parseFloat(sum.issmtr), 0);
                            const totissInch = rows.reduce((acc, sum) => acc + parseFloat(sum.issInch), 0);
                            const totissmqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issmqty), 0);

                            return (
                                <React.Fragment key={idx}>
                                    <tr>
                                        <td rowSpan={6}>
                                            {mat.materialNm}

                                            <br />
                                            {materialSktlink?.some(item => item.matId === mat.matId) ? (
                                                <p style={{ color: "red", textDecoration: "underline", cursor: "pointer" }} onClick={() => handleStockAddClick(mat.matId)}>
                                                    stock add
                                                </p>
                                            ) :
                                                <p style={{ color: "blue" }} onClick={() => handleStockAddClick(mat.matId)}>(
                                                    {mat.mtype === "Pcs" ? mat.stock.balTotqty :
                                                        mat.mtype === "Mtr" ? mat.stock.balmtr :
                                                            mat.mtype === "Inch" ? mat.stock.balInch : null}
                                                    {" "}
                                                    {mat.mtype}
                                                    )
                                                </p>
                                            }

                                        </td>
                                        <td>Material Length</td>
                                        {rows.map(i => (
                                            <td key={i.matsize}>{i.matsize}</td>
                                        ))}
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>Per Size M. Qty.</td>
                                        {rows.map(i => (
                                            <td key={i.matsize}>{i.matgqty}</td>
                                        ))}
                                        <td></td>
                                    </tr>
                                    {/* style={{ fontWeight: 800, background: '#fccfa1' }} */}
                                    <tr>
                                        <td>Qty.</td>
                                        {qtyArr.map((q, i) => (
                                            <td key={i}>{q}</td>
                                        ))}
                                        {/* <td><b>{totitemqty}</b></td> */}
                                        <td></td>
                                    </tr>


                                    <tr style={{ fontWeight: 800, background: '#fdd4d4' }}>
                                        <td>Mtr.</td>
                                        {rows.map(i => (
                                            <td key={i.matsize}>{i.issmtr}</td>
                                        ))}
                                        <td><b>{totissmtr.toFixed(2)}</b></td>
                                    </tr>

                                    <tr style={{ fontWeight: 800, background: '#85e07c' }}>
                                        <td>Inch.</td>
                                        {rows.map(i => (
                                            <td key={i.matsize}>{i.issInch}</td>
                                        ))}
                                        <td><b>{totissInch.toFixed(2)}</b></td>
                                    </tr>


                                    <tr style={{ fontWeight: 800, background: '#b4b4f7' }}>
                                        <td>Total Qty.</td>
                                        {rows.map(i => (
                                            <td key={i.matsize}>{i.issmqty}</td>
                                        ))}
                                        <td><b>{totissmqty.toFixed(2)}</b></td>
                                    </tr>
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
                <Grid item xs={12} md={6}>
                    <Button variant="contained" color="primary" onClick={handleDeleteMaterial} disabled={selectedRows.length === 0}>Delete</Button>
                </Grid>

                <Grid item xs={12}>
                    <div style={{ marginTop: '1%' }}>
                        <TableContainer width={400}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Select</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Location</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Barcode</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Material</TableCell>

                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'> M. Qty & Type</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Per Packet Qty & Type</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Stock Packet Qty</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Stock Total Qty</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Stock Mtr</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Stock Inches</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableRows?.map((row, index) => (
                                        <TableRow key={row.id}>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                <Checkbox
                                                    checked={selectedRows.includes(row.barcode)}
                                                    onChange={() => handleCheckboxChange(row.barcode)}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>{row.locNm}</TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>{row.barcode}</TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>

                                                {row.materialNm}
                                            </TableCell>

                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>

                                                {row.size}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>

                                                {row.mqty}{" "} {row.mtype}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>

                                                {row.perpktqty}{" "}{row.ptype}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>

                                                {row.balpqty} {" "}

                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    name='outqty'
                                                    value={row.outqty}
                                                    onChange={(e) => handleInputChange(index, 'outqty', e.target.value)}
                                                    style={{ width: '100px', padding: '2px' }}
                                                    readOnly={row.qty === '0'}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.balTotqty}{" "}

                                                {row.balTotqty > 0 ?
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        name='outBoxQty'
                                                        value={row.outBoxQty}
                                                        onChange={(e) => handleInputChange(index, 'outBoxQty', e.target.value)}
                                                        style={{ width: '100px', padding: '2px' }}
                                                    /> :
                                                    null}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.balmtr}
                                                {" "}
                                                {row.balmtr > 0 ?
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        name='outMtr'
                                                        value={row.outMtr}
                                                        onChange={(e) => handleInputChange(index, 'outMtr', e.target.value)}
                                                        style={{ width: '100px', padding: '2px' }}
                                                    /> : null}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>
                                                {row.balInch}
                                                {" "}
                                                {row.balInch > 0 ?
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        name='outInch'
                                                        value={row.outInch}
                                                        onChange={(e) => handleInputChange(index, 'outInch', e.target.value)}
                                                        style={{ width: '100px', padding: '2px' }}
                                                    /> : null}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </Grid>

                {tableRows?.length > 0 &&
                    <Grid item xs={12} textAlign="center">
                        <Button variant="contained" color="primary" onClick={() => onSave(tableRows)}>
                            save
                        </Button>
                    </Grid>}
            </div>
        </>
    );
}

export default SOMaterialOut;
